export default {"src":"/fly/_next/static/media/ec.88524765.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};